export default "__VITE_ASSET__D5HuRDq2__"